import { getContent } from 'pp-react-l10n';

// Using L10N html to replace dangerouslySetInnerHTML
function getHTMLElement(rawHtml, options) {
  return getContent({
    content: {
      innerMessage: rawHtml,
    },
    path: 'innerMessage',
    useHTML: options.useHTML || false,
  });
}

export default getHTMLElement;
